export var DepartmentSettingsKeys;
(function (DepartmentSettingsKeys) {
    DepartmentSettingsKeys["SOURCE"] = "Source";
    DepartmentSettingsKeys["DEVICES"] = "Devices";
    DepartmentSettingsKeys["SETUP_REQUIRED"] = "setupRequired";
    DepartmentSettingsKeys["OFFLINE_THRESHOLD"] = "OfflineThreshold";
    DepartmentSettingsKeys["DO_NOT_NOTIFY"] = "DoNotNotifyWhenDeviceOffline";
    DepartmentSettingsKeys["REPORTS"] = "Reports";
    DepartmentSettingsKeys["PDF"] = "Pdf";
    DepartmentSettingsKeys["NOTIFICATIONS"] = "Notifications";
    DepartmentSettingsKeys["BUZZER"] = "Buzzer";
    DepartmentSettingsKeys["DEVICE_ID"] = "DeviceId";
    DepartmentSettingsKeys["SEQUENCE"] = "Sequence";
    DepartmentSettingsKeys["LOGGERS"] = "Loggers";
    DepartmentSettingsKeys["CALIBRATION"] = "Calibration";
    DepartmentSettingsKeys["CUSTOM"] = "Custom";
    DepartmentSettingsKeys["EXPIRESAT"] = "ExpiresAt";
})(DepartmentSettingsKeys || (DepartmentSettingsKeys = {}));
export class DepartmentSettings {
    setupRequired = true;
    /*TODO: Tieto default hodnoty nie su staticke a daju sa zmenit v system settingoch.
    V pripade ze si user nenastavi vlastne hodnoty sa vsak neposielaju a tym padom FE zobrazuje nespravne hodnoty.*/
    Source = {
        OfflineThreshold: 900,
        DoNotNotifyWhenDeviceOffline: 'false'
    };
    Notifications = {
        Buzzer: { DeviceId: null, Sequence: null }
    };
    Loggers = { Calibration: { Custom: { ExpiresAt: null } } };
    constructor() { }
    static fromApi(data) {
        return DepartmentSettings.define(data);
    }
    static define(data) {
        let companySettings = new DepartmentSettings();
        if (typeof data.setupRequired == 'string')
            companySettings.setupRequired = toBoolean(data.setupRequired);
        else
            companySettings.setupRequired = data.setupRequired || companySettings.setupRequired;
        companySettings.Source.OfflineThreshold = data.Source?.OfflineThreshold || companySettings.Source?.OfflineThreshold;
        companySettings.Source.DoNotNotifyWhenDeviceOffline =
            data.Source?.DoNotNotifyWhenDeviceOffline || companySettings.Source?.DoNotNotifyWhenDeviceOffline;
        companySettings.Notifications.Buzzer.DeviceId =
            data.Notifications?.Buzzer?.DeviceId || companySettings.Notifications?.Buzzer?.DeviceId;
        companySettings.Notifications.Buzzer.Sequence =
            data.Notifications?.Buzzer?.Sequence || companySettings.Notifications?.Buzzer?.Sequence;
        companySettings.Loggers.Calibration.Custom.ExpiresAt =
            data.Loggers?.Calibration?.Custom?.ExpiresAt || companySettings.Loggers?.Calibration?.Custom?.ExpiresAt;
        return companySettings;
    }
}
function toBoolean(stringValue) {
    if (stringValue.toLowerCase() === 'true') {
        return true;
    }
    else if (stringValue.toLowerCase() === 'false')
        return false;
}
function toObject(stringValue) {
    let configuration = JSON.parse(stringValue);
    return configuration;
}
